export const messageValidator = {
    email_required: "* Email không được bỏ trống",
    email_invalid: "* Emailが正しくありません。もう一度確認してください",
    password_required: "* Mật khẩu không được bỏ trống",
    password_min: "*Passwordは最低６文字以上入力してください",
    user_name_required: "* Tên hiển thị không được bỏ trống",
    user_name_size: "* 3 - 15字までのユーザー名"
}